import { BusEvent } from '@web/common';

export class AdminSubscriptionPricesChangedBusEvent extends BusEvent {}
